import { RoutingService } from 'src/app/services/routingService/routing.service';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ResolverService implements Resolve<any> {
  public token: any;
  constructor(private routingService: RoutingService) { }
  resolve(route: ActivatedRouteSnapshot) {
    this.token = this.routingService.decodeToken();
    if (this.token) {
      this.routingService.nextStep();
    } else {
      return true;
    }
  }
}
